<script lang="ts">
  import HubspotForm from '$components/hubspot-form.svelte';
  import { cn } from '$lib/utils/tailwind';

  import type { HubspotFormStoryblok } from '$types/bloks';

  let className: string | undefined = undefined;
  export { className as class };

  export let blok: HubspotFormStoryblok;
  $: ({ form } = blok);
</script>

{#if form}
  <section class={cn('flex h-full w-full overflow-hidden', className)}>
    <div
      class="container mx-auto flex h-fit w-full max-w-richtext rounded-4xl bg-highlight-foreground bg-opacity-3 p-20"
    >
      <HubspotForm {form} />
    </div>
  </section>
{/if}
